<template>
  <div class="noiseLevelCompute">
    <top :toolSort="toolSort"></top>
    <div class="main">
      <div class="computeForm">
        <el-form ref="form" :rules="rules" :model="computeForm" label-width="100px">
          <div class="computeSelect">
            <el-form-item label="计算类型">
              <el-select v-model="computeForm.type" placeholder="请选择计算类型">
                <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="shortSelect" label="计算噪声数">
              <el-select v-model="computeForm.computeNoiseNum" placeholder="请选择计算噪声数">
                <el-option v-for="item in computeNoiseNum" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="shortSelect" label="计算单位">
              <el-select v-model="computeForm.computeUnit" placeholder="请选择计算噪声数">
                <el-option v-for="item in computeUnit" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-table border :data="computeForm.tableData">
            <el-table-column label="序号" type="index" align="center" width="80">
            </el-table-column>
            <el-table-column label="噪声检测值" align="center">
              <template slot-scope='scope'>
                <el-form-item :rules="rules.noiseNum" :prop="'tableData.'+scope.$index+'.noiseNum'">
                  <el-input v-model="scope.row.noiseNum"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="接触时间" align="center" v-if="computeForm.type === 1||computeForm.type === 2">
              <template slot-scope='scope'>
                <el-form-item :rules="isTimeRequire?rules.touchTime:norule" :prop="'tableData.'+scope.$index+'.touchTime'">
                  <el-input v-model="scope.row.touchTime"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
             <el-table-column label="天数" align="center" v-if="computeForm.type === 2">
              <template slot-scope='scope'>
                <el-form-item :rules="isTimeRequire?rules.touchDay:norule" :prop="'tableData.'+scope.$index+'.touchDay'">
                  <el-input v-model="scope.row.touchDay"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
                  fixed="right"
                  label="操作"
                  width="100">
              <template slot-scope="scope">
                 <el-button @click="handleDele(scope.row,scope.$index)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-form-item>
            <div class="btn">
              <el-button size="small" type="primary" @click='submit'>计算</el-button>
              <el-button size="small" @click='resetForm'>重置</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="result">
        <div class="title">计算结果</div>
        <p>{{result}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import top from '../subComponents/top.vue'
  export default {
    data() {
      return {
        norule:{

        },
        isTimeRequire:true,
        toolSort: '',
        computeForm: {
          type: 1,
          computeNoiseNum: 1,
          computeUnit: 1,
          tableData:[]
        },
        result:'',//计算结果
        type: [
          {
            label: '一天8h等效A声级',
            value: 1
          },
          {
            label: '每周40h等效A声级',
            value: 2
          },
          {
            label: '噪声平均值计算',
            value: 3
          }
        ],
        computeNoiseNum: [],
        computeUnit: [{
          label: '小时（h）',
          value: 1
        }],
        rules:{
          noiseNum:[{required: true, message: '请输入噪声检测值'}],
          touchTime:[{required: true, message: '请输入接触时间'}],
          touchDay:[{required: true, message: '请输入接触天数'}]
        }
      }
    },
    created() {
      this.toolSort = this.$route.params.sort
      for (let i = 1; i <= 10; i++) {
        this.computeNoiseNum.push({
          label: i,
          value: i
        })
      }
      this.computeForm.tableData.push({noiseNum:'',touchTime:'',touchDay:''})
    },
    watch:{
      'computeForm.computeNoiseNum'(newval,oldVal){
        let subtract = newval - oldVal
        if(subtract>0){
          for(let i=1;i<=subtract;i++){
            this.computeForm.tableData.push({noiseNum:'',touchTime:'',touchDay:''})
          }
        }else if(subtract<0){
          this.computeForm.tableData = this.computeForm.tableData.slice(0,newval)
        }

      },
      'computeForm.type'(newval){
        if(newval === 3 || newval === 4){
          this.isTimeRequire = false
        }else{
          this.isTimeRequire = true
        }
      }
    },
    components: {
      top
    },
    methods: {
      //删除
      handleDele(row,i){
        this.computeForm.tableData.splice(i,1)
        this.computeForm.computeNoiseNum -= 1
      },
      submit(){
        console.log(this.computeForm)
        if(this.computeForm.type === 1){
          this.typeOneCompute()
        }else if(this.computeForm.type === 2){
          this.typeTwoCompute()
        }else if(this.computeForm.type === 3){
          this.typeThreeCompute()
        }else if(this.computeForm.type === 4){
          this.typeFourCompute()
        }

      },
      
      // //非稳态噪声全天等效声级计算公式
      // typeOneCompute(){
      //   let time = 0
      //   let computed = 0
      //   this.computeForm.tableData.forEach(item=>{
      //     time += parseInt(item.touchTime)
      //     computed += item.touchTime*Math.pow(10,0.1*(item.noiseNum))
      //   })

      //   this.result = 10*(Math.log(1/time*computed)/Math.log(10))
      // },
      //一天8h等效A声级计算公式
      typeOneCompute(){
        let time = 0
        let computed = 0
        this.computeForm.tableData.forEach(item=>{
          time += parseInt(item.touchTime)
          computed += item.touchTime * Math.pow(10, ((0.1 * item.noiseNum) * 1.0))
        })
        // let computeUnit = 1
        // if(this.computeForm.computeUnit === 1){
        //   computeUnit = 8
        // }else if(this.computeForm.computeUnit === 2){
        //   computeUnit = 480
        // }
       this.result = (10 * Math.log10(computed/time) + 10*Math.log10(time/8)).toFixed(1)
      },
      //每周40h等效A声级
      typeTwoCompute(){ 
        // 10*LOG10(1/8*(接触时间*POWER(10,0.1*噪声测量值))) +10*LOG10(一周接触天数/5)
        let time = 0
				let totalTime = 0
				let computed = 0
        this.computeForm.tableData.forEach(item=>{
          console.log(item)
         computed += Math.pow(10, (0.1 * item.noiseNum) * 1.0) * item.touchDay * item.touchTime
         time += parseInt(item.touchTime)
					totalTime += item.days * item.touchTime
        })
       this.result = (10 * Math.log10(1 / 40 * computed)).toFixed(1)
      },
      //噪声平均值计算
      typeThreeCompute(){
        let computed = 0
        let counts = 0
        this.computeForm.tableData.forEach((item,i)=>{
          computed += Math.pow(10,0.1*item.noiseNum*1.0)
          counts = i+1
        })
       this.result = (10 * Math.log10((1 / counts) * computed)).toFixed(1)
      },
       resetForm(formName) {
          this.$refs.form.resetFields();
       }
    },
  }
</script>

<style scoped="scoped">
  .el-button--text{
    color: red;
  }
  .computeForm {
    display: flex;
    justify-content: center;
    padding: 1.25rem;
    border-right: 0.0625rem #999 dotted;
  }

  .computeSelect {
    display: flex;
    width: 35rem;
    justify-content: space-around;
    margin-bottom: 0.625rem;
  }
  .btn{
    display: flex;
    justify-content: center;
    margin-top: 0.625rem;
  }
  .el-form-item{
    margin-bottom: 0;
  }
  .main{
    display: flex;
    margin-top: 0.625rem;
  }
  .result{
    padding: 1.25rem;
  }
  .title{
    font-size: 14px;
    color: #666;
  }
</style>















// WEBPACK FOOTER //
// src/components/subPage/noiseLevelCompute.vue